import SecureBaseModel from './SecureBaseModel';

class SyncWorkerModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static SYNC_WORKER_ADD = 'sync-worker-add';
    static SYNC_WORKER_RETRIEVE = 'sync-worker-retrieve';
    static SYNC_WORKER_UPDATE = 'sync-worker-update';
    static SYNC_WORKER_REMOVE = 'sync-worker-remove';
    static SYNC_WORKER_LIST = 'sync-worker-list';
    static SYNC_WORKER_ENABLED = 'sync-worker-enabled';

    constructor() {
        super();
    }

    // params { userEmail: value, sessionId: value, codeName: value, capacity: value, process: value, delay: value(millis), updatedBy: value(email), enabled: value(bool) }
    async addNewWorker(params) {
        return await this.postData(SyncWorkerModel.SYNC_WORKER_ADD, params);
    }

    // params { userEmail: value, sessionId: value, id: value, codeName: value } either of the two
    async retrieveWorker(params) {
        return await this.postData(SyncWorkerModel.SYNC_WORKER_RETRIEVE, params);
    }

    // params { userEmail: value, sessionId: value, id: value, codeName: value, capacity: value, process: value, delay: value(millis), updatedBy: value(email), enabled: value(bool) }
    async updateWorker(params) {
        return await this.postData(SyncWorkerModel.SYNC_WORKER_UPDATE, params);
    }

    // params { userEmail: value, sessionId: value, id: value }
    async removeWorker(params) {
        return await this.postData(SyncWorkerModel.SYNC_WORKER_REMOVE, params);
    }

    // params { userEmail: value, sessionId: value }
    async getAllWorkers(params) {
        return await this.postData(SyncWorkerModel.SYNC_WORKER_LIST, params);
    }

    // params { userEmail: value, sessionId: value }
    async operationAllowed(params) {
        return await this.postData(SyncWorkerModel.SYNC_WORKER_ENABLED, params);
    }
}

export default SyncWorkerModel;
